import React, { useState } from "react";
import { Text } from "@/styles/reactnative";
import {
  CryptoCurrencyTrendHeader,
  CryptoCurrencyTrendSection,
} from "../styles";
import MarketTrendTabs from "../../MarketTrendTabs";
import CryptoMarketGraph from "./CryptoMarketGraph";
import CryptoMarketFooter from "./CryptoMarketFooter";
import { useTranslation } from "react-i18next";

const CryptoMarkets = () => {
  const [tab, setTab] = useState("7d");
  const tabs = ["7d", "1m", "3m", "6m", "1y"];
  const { t } = useTranslation();
  return (
    <CryptoCurrencyTrendSection>
      <CryptoCurrencyTrendHeader>
        <Text size={16} style={{ fontWeight: "600" }}>
          {t("marketCapDistribution")}
        </Text>
        <MarketTrendTabs tab={tab} setTab={setTab} tabs={tabs} />
      </CryptoCurrencyTrendHeader>
      <CryptoMarketGraph />
      <CryptoMarketFooter />
    </CryptoCurrencyTrendSection>
  );
};

export default React.memo(CryptoMarkets);
